import { Field } from "formik";
import * as React from "react";
import SignatureCanvas from "react-signature-canvas";
import { MembershipFormType, WaFormFieldConstants } from "./Constants";
import FormField from "./FormField";
import { renderOptions } from "./FunctionLib";
import { useWaMembershipFormContext } from "./WaMembershipFormContext";
import { IStepProps } from "./WaMembershipFormStep0";

export const stepTwoFields = [
	WaFormFieldConstants.signature,
	WaFormFieldConstants.application,
	WaFormFieldConstants.declaration,
	WaFormFieldConstants.adminComRefDetails,
];

const WaMembershipFormStep2: React.FC<IStepProps> = (props: IStepProps) => {
	const formContext = useWaMembershipFormContext();
	let sigCanvas = React.useRef({} as any);
	let sigWrapper = React.useRef<HTMLDivElement>(null);
	return (
		<div className={`donStep1 container`}>
			<h1 className={"donFormHeader donOpposite" + formContext.colorTheme}>
				Declarations and signature
			</h1>
			<div className="formDeclarationsNSign">
				<div className="formDeclarations" style={{ marginBottom: "1rem" }}>
					<div
						data-tip={`${
							props.errors["application"] && props.touched["application"]
								? props.errors["application"]
								: ""
						}`}
						className="formCheckBoxGap waFormFieldGap formCheckboxWrapper"
					>
						<Field
							className={`formCheckBox 
                                        ${
											props.errors["application"] &&
											props.touched["application"]
												? " waFormInputError "
												: ""
										}
                                        `}
							component="div"
							name={WaFormFieldConstants.application}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.application] === true
								}
								name={WaFormFieldConstants.application}
								type="checkbox"
								id="application"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="application">
								{props.formType == MembershipFormType.Join ? (
									<div>
										I wish to apply to become a member of the Western Australian
										Labor Party
									</div>
								) : (
									<div>
										I wish to renew my membership to WA Labor and hereby
										authorise WA Labor to debit my card/account in accordance
										with the table above, and to continue deducting payments
										from my card/account in accordance with{" "}
										<a href="https://walabor.org.au/about/rules/">
											WA Labor's Rules
										</a>{" "}
										until I request otherwise in writing.
									</div>
								)}
							</label>
						</Field>
					</div>
					{props.values[WaFormFieldConstants.application] &&
						props.formType === MembershipFormType.Join && (
							<div
								data-tip={`${
									props.errors[WaFormFieldConstants.firstTimeMember] &&
									props.touched[WaFormFieldConstants.firstTimeMember]
										? props.errors["firstTimeMember"]
										: ""
								}`}
								className={`formJoinFirstTimeButtons ${
									props.errors[WaFormFieldConstants.firstTimeMember] &&
									props.touched[WaFormFieldConstants.firstTimeMember]
										? " waFormInputError "
										: ""
								}
                                    `}
							>
								<Field component="div" name={WaFormFieldConstants.firstTimeMember}>
									<div className="formRadioButtonWrapper formRadioButtonFirstTime">
										<input
											defaultChecked={
												props.values[
													WaFormFieldConstants.firstTimeMember
												] === "yes"
											}
											name={WaFormFieldConstants.firstTimeMember}
											type="radio"
											value="yes"
											className="formRadioTick"
											id="firstTimeYes"
										/>
										<label className="formCheckboxLabel" htmlFor="firstTimeYes">
											I am joining for the first time
										</label>
									</div>
									<div className="formRadioButtonWrapper formRadioButtonFirstTime">
										<input
											defaultChecked={
												props.values[
													WaFormFieldConstants.firstTimeMember
												] === "no"
											}
											name={WaFormFieldConstants.firstTimeMember}
											type="radio"
											value="no"
											className="formRadioTick"
											id="firstTimeNo"
										/>
										<label className="formCheckboxLabel" htmlFor="firstTimeNo">
											I was previously a member
										</label>
									</div>
								</Field>
							</div>
						)}
					{props.values[WaFormFieldConstants.firstTimeMember] === "no" &&
						props.values[WaFormFieldConstants.application] === true && (
							<FormField
								type="text"
								name={WaFormFieldConstants.previousYearMembership}
								component="select"
								placeholder=""
								errors={props.errors}
								touched={props.touched}
								isColumn={false}
								className="form-control standard-form-group"
								colorTheme={formContext.colorTheme}
								value={props.values[WaFormFieldConstants.previousYearMembership]}
								//class="formJoinFirstYearDropDown"
							>
								{formContext.years.map(renderOptions)}
							</FormField>
						)}
					<div
						data-tip={`${
							props.errors["declaration"] && props.touched["declaration"]
								? props.errors["declaration"]
								: ""
						}`}
						className={`waFormFieldGap formCheckboxWrapper ${
							props.errors["declaration"] && props.touched["declaration"]
								? " waFormInputError "
								: ""
						}
                                        `}
					>
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.declaration}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.declaration] === true
								}
								name={WaFormFieldConstants.declaration}
								type="checkbox"
								value="yes"
								id="declaration"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="declaration">
								I declare that I am not a member of any other political party and
								that I will abide by the Rules of the Party
							</label>
						</Field>
					</div>
					<div style={{ marginTop: "1rem" }}>Tick the below if you have ever:</div>
					<div className="formAdminComRefWrapper">
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.adminComRef1}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.adminComRef1] === true
								}
								name={WaFormFieldConstants.adminComRef1}
								type="checkbox"
								value="yes"
								id="adminComRef1"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="adminComRef1">
								Been expelled form the party
							</label>
						</Field>
					</div>
					<div style={{ marginTop: "1rem" }} className="formAdminComRefWrapper">
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.adminComRef2}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.adminComRef2] === true
								}
								name={WaFormFieldConstants.adminComRef2}
								type="checkbox"
								value="yes"
								id="adminComRef2"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="adminComRef2">
								Been a non-ALP candidate for parliamentary office
							</label>
						</Field>
					</div>
					<div className="formAdminComRefWrapper">
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.adminComRef3}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.adminComRef3] === true
								}
								name={WaFormFieldConstants.adminComRef3}
								type="checkbox"
								value="yes"
								id="adminComRef3"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="adminComRef3">
								Campaigned on behalf of a non-ALP candidate
							</label>
						</Field>
					</div>
					<div className="formAdminComRefWrapper">
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.adminComRef4}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.adminComRef4] === true
								}
								name={WaFormFieldConstants.adminComRef4}
								type="checkbox"
								value="yes"
								id="adminComRef4"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="adminComRef4">
								Previously resigned from the party
							</label>
						</Field>
					</div>
					<div className="formAdminComRefWrapper">
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.adminComRef5}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.adminComRef5] === true
								}
								name={WaFormFieldConstants.adminComRef5}
								type="checkbox"
								value="yes"
								id="adminComRef5"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="adminComRef5">
								Are or were a Member of any Parliament
							</label>
						</Field>
					</div>
					<div className="formAdminComRefWrapper">
						<Field
							className={"formCheckBox"}
							component="div"
							name={WaFormFieldConstants.adminComRef6}
						>
							<input
								defaultChecked={
									props.values[WaFormFieldConstants.adminComRef6] === true
								}
								name={WaFormFieldConstants.adminComRef6}
								type="checkbox"
								value="yes"
								id="adminComRef6"
								className="formRadioTick"
							/>
							<label className="formCheckboxLabel" htmlFor="adminComRef6">
								Are serving a custodial sentence
							</label>
						</Field>
					</div>
					{(props.values[WaFormFieldConstants.adminComRef1] === true ||
						props.values[WaFormFieldConstants.adminComRef2] === true ||
						props.values[WaFormFieldConstants.adminComRef3] === true ||
						props.values[WaFormFieldConstants.adminComRef4] === true ||
						props.values[WaFormFieldConstants.adminComRef5] === true ||
						props.values[WaFormFieldConstants.adminComRef6] === true) && (
						<Field
							component="textarea"
							name={WaFormFieldConstants.adminComRefDetails}
							className="form-control standard-form-group"
							style={{ marginTop: "1rem" }}
							placeholder="If you selected any of the options above, please provide details"
							value={props.values[WaFormFieldConstants.adminComRefDetails]}
						/>
					)}
				</div>
				<div>
					<div
						data-tip={`${
							props.errors[WaFormFieldConstants.signature] &&
							props.touched[WaFormFieldConstants.signature]
								? props.errors[WaFormFieldConstants.signature]
								: ""
						}`}
						className="formSignatureWrapper"
					>
						<div style={{ width: "100%" }} ref={sigWrapper}>
							<SignatureCanvas
								ref={(ref) => {
									sigCanvas.current = ref as any;
								}}
								clearOnResize={true}
								canvasProps={{
									width: sigWrapper?.current?.clientWidth,
									height: sigWrapper?.current?.clientHeight,
									className: `formSignature ${
										props.errors[WaFormFieldConstants.signature] &&
										props.touched[WaFormFieldConstants.signature]
											? " waFormInputError "
											: ""
									}`,
								}}
								onEnd={() => {
									props.setFieldValue(
										WaFormFieldConstants.signature,
										sigCanvas.current.toDataURL()
									);
									const newTouched = { ...props.touched };
									newTouched[WaFormFieldConstants.signature] = true;
									props.setTouched(newTouched);
								}}
							/>
						</div>
						<button
							className={`formSignatureButton ${formContext.colorTheme}ContSubButton`}
							type="button"
							onClick={() => {
								sigCanvas.current.clear();
								props.setFieldValue(WaFormFieldConstants.signature, "");
							}}
						>
							Clear
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WaMembershipFormStep2;
